import { LocalUserSession } from 'types/common';
import { LOCAL_STORAGE_STORE_CONSTANTS } from 'constants/general';
import { parseJwt } from 'utils/parseJwt';

export default function getTokenFromStorage() {
    let localUserSession = {} as LocalUserSession;
    const localUser = localStorage.getItem(LOCAL_STORAGE_STORE_CONSTANTS.X_USER) as string | null;
    if (!localUser) {
        return null;
    }
    localUserSession = JSON.parse(localUser);
    const { token } = localUserSession;

    return token;
}
